export const EVENT_DETAILS_REMIND_ME_UNLEASH_EXPERIMENT = "event_details_page_remind_me"
export const EVENT_DETAILS_REMIND_ME_UNLEASH_EXPERIMENT_VARIANTS = {
  NEW_REMIND_ME: "new_remind_me",
  OLD_SAVE: "old_save",
}
